// extracted by mini-css-extract-plugin
export default {"div":"faq_div__GqfYu"};